Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  i18n: true,
  Locales: true,
  DefaultLocale: true,
  LocalePickerKey: true,
  GenerateId: true,
  Storage: true,
  useOrdinals: true,
  ShuffleArray: true,
  EmailRegex: true,
  WebAccessibilityRole: true,
  useNativeDriver: true,
  useWindowDimensions: true,
  UseWindowDimensionsProvider: true,
  SearchObject: true
};
Object.defineProperty(exports, "DefaultLocale", {
  enumerable: true,
  get: function get() {
    return _i18n.DefaultLocale;
  }
});
Object.defineProperty(exports, "EmailRegex", {
  enumerable: true,
  get: function get() {
    return _EmailRegex.EmailRegex;
  }
});
Object.defineProperty(exports, "GenerateId", {
  enumerable: true,
  get: function get() {
    return _GenerateId.GenerateId;
  }
});
Object.defineProperty(exports, "LocalePickerKey", {
  enumerable: true,
  get: function get() {
    return _i18n.LocalePickerKey;
  }
});
Object.defineProperty(exports, "Locales", {
  enumerable: true,
  get: function get() {
    return _i18n.Locales;
  }
});
Object.defineProperty(exports, "SearchObject", {
  enumerable: true,
  get: function get() {
    return _SearchObject.SearchObject;
  }
});
Object.defineProperty(exports, "ShuffleArray", {
  enumerable: true,
  get: function get() {
    return _ShuffleArray.ShuffleArray;
  }
});
Object.defineProperty(exports, "Storage", {
  enumerable: true,
  get: function get() {
    return _Storage.Storage;
  }
});
Object.defineProperty(exports, "UseWindowDimensionsProvider", {
  enumerable: true,
  get: function get() {
    return _useWindowDimensions.UseWindowDimensionsProvider;
  }
});
Object.defineProperty(exports, "WebAccessibilityRole", {
  enumerable: true,
  get: function get() {
    return _WebAccessibilityRole.WebAccessibilityRole;
  }
});
Object.defineProperty(exports, "i18n", {
  enumerable: true,
  get: function get() {
    return _i18n.i18n;
  }
});
Object.defineProperty(exports, "useNativeDriver", {
  enumerable: true,
  get: function get() {
    return _useNativeDriver.useNativeDriver;
  }
});
Object.defineProperty(exports, "useOrdinals", {
  enumerable: true,
  get: function get() {
    return _useOrdinals.useOrdinals;
  }
});
Object.defineProperty(exports, "useWindowDimensions", {
  enumerable: true,
  get: function get() {
    return _useWindowDimensions.useWindowDimensions;
  }
});
var _i18n = require("./i18n");
var _GenerateId = require("./GenerateId");
var _Storage = require("./Storage");
var _useOrdinals = require("./useOrdinals");
var _ShuffleArray = require("./ShuffleArray");
var _EmailRegex = require("./EmailRegex");
var _WebAccessibilityRole = require("./WebAccessibilityRole");
var _useNativeDriver = require("./useNativeDriver");
var _useWindowDimensions = require("./useWindowDimensions");
var _SearchObject = require("./SearchObject");
var _Navigation = require("./Navigation");
Object.keys(_Navigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Navigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Navigation[key];
    }
  });
});
var _Controllers = require("./Controllers");
Object.keys(_Controllers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Controllers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Controllers[key];
    }
  });
});
var _ConfigurationContext = require("./ConfigurationContext");
Object.keys(_ConfigurationContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ConfigurationContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ConfigurationContext[key];
    }
  });
});
var _Analytics = require("./Analytics");
Object.keys(_Analytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Analytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Analytics[key];
    }
  });
});
var _SafeAreaProvider = require("./SafeAreaProvider");
Object.keys(_SafeAreaProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SafeAreaProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SafeAreaProvider[key];
    }
  });
});
var _isCommitmentStateCompleted = require("./isCommitmentStateCompleted");
Object.keys(_isCommitmentStateCompleted).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _isCommitmentStateCompleted[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isCommitmentStateCompleted[key];
    }
  });
});
var _ArraySorter = require("./ArraySorter");
Object.keys(_ArraySorter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ArraySorter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArraySorter[key];
    }
  });
});
var _useInvalidateDataQueries = require("./useInvalidateDataQueries");
Object.keys(_useInvalidateDataQueries).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useInvalidateDataQueries[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useInvalidateDataQueries[key];
    }
  });
});
var _useErrorMessage = require("./useErrorMessage");
Object.keys(_useErrorMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useErrorMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useErrorMessage[key];
    }
  });
});
var _WritableKeys = require("./WritableKeys");
Object.keys(_WritableKeys).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WritableKeys[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _WritableKeys[key];
    }
  });
});
var _ReplaceParam = require("./ReplaceParam");
Object.keys(_ReplaceParam).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ReplaceParam[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReplaceParam[key];
    }
  });
});
var _GetEmailsFromString = require("./GetEmailsFromString");
Object.keys(_GetEmailsFromString).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GetEmailsFromString[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetEmailsFromString[key];
    }
  });
});
var _GetCommitment = require("./GetCommitment");
Object.keys(_GetCommitment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GetCommitment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetCommitment[key];
    }
  });
});
var _DestroySuppression = require("./DestroySuppression");
Object.keys(_DestroySuppression).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DestroySuppression[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DestroySuppression[key];
    }
  });
});
var _LinkContext = require("./LinkContext");
Object.keys(_LinkContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _LinkContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LinkContext[key];
    }
  });
});
var _AuthContext = require("./AuthContext");
Object.keys(_AuthContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AuthContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AuthContext[key];
    }
  });
});
var _useUserRegionId = require("./useUserRegionId");
Object.keys(_useUserRegionId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUserRegionId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUserRegionId[key];
    }
  });
});
var _GetPagination = require("./GetPagination");
Object.keys(_GetPagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GetPagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetPagination[key];
    }
  });
});
var _HostUri = require("./HostUri");
Object.keys(_HostUri).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _HostUri[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostUri[key];
    }
  });
});
var _useScrollTo = require("./useScrollTo");
Object.keys(_useScrollTo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useScrollTo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useScrollTo[key];
    }
  });
});
var _GetFootprintAccuracy = require("./GetFootprintAccuracy");
Object.keys(_GetFootprintAccuracy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GetFootprintAccuracy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetFootprintAccuracy[key];
    }
  });
});
var _GetShareUrl = require("./GetShareUrl");
Object.keys(_GetShareUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GetShareUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetShareUrl[key];
    }
  });
});